"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoadingContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLoadingContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;
